import { Helmet } from 'react-helmet-async'

import { PRODUCTION_ORIGIN } from '../../../constants'

export const ReproBooster = () => {
  const isProduction = () => {
    const { origin } = window.location
    if (origin.startsWith(PRODUCTION_ORIGIN)) {
      return true
    }

    return false
  }

  if (!isProduction() || process.env.NODE_ENV !== 'production') {
    return null
  }

  return (
    <Helmet>
      <script src="https://booster.reproio.com/bundled/js/resource_scheduler?token=ce9569de-31b5-4be1-91a7-d224d809c976" />
      <script src="https://booster.reproio.com/assets/js/lcpjs/loader.js" />
    </Helmet>
  )
}
